import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { IQuestion } from '../../../../interfaces/question.interface';

@Component({
  selector: 'app-integer-answer',
  templateUrl: './integer-answer.component.html',
  styleUrls: ['./integer-answer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IntegerAnswerComponent {
  @Input() question: IQuestion;
  form = this.fb.group({
    value: null,
  });
  constructor(private fb: UntypedFormBuilder) {}
}
